<template lang='pug'>
    h1.has-text-centered {{ this.time }}
</template>

<script>
import moment from 'moment'
import { API } from '../services'

export default {
  mounted: function () {
    this.$nextTick(function () {
      this.getTime()
    })
  },
  data () {
    return {
      time: null,
      worker: null
    }
  },
  methods: {
    async getTime () {
      const { accessData } = this.$store.state

      let id

      if (accessData.browserRecord && accessData.browserRecord.id) {
        id = accessData.browserRecord.id
      } else if (accessData.browserId) {
        id = accessData.browserId
      } else if (accessData.compMan) {
        id = accessData.compMan.id
      }

      this.updateTimeWorker(id)

      document.addEventListener("visibilitychange", () => {
        if (!document.hidden){
          this.worker.terminate()
          this.updateTimeWorker(id)
        }
      })
    },
    async updateTimeWorker (id) {
      /*
        Quando deployado em dominios dentro de uma estrutura de pastas, ex: hml.pontotel.com.br/alpha/new-web, é preciso garantir o caminho correto usando o pathname.
        A estrutura da url foi montada para que o arquivo seja localizado na pasta pública relativa correta.
      */
      const {origin, pathname} = window.location
      const urlDoWorker = `${origin}${pathname}js/currentTimeWorker.js`
      this.worker = new Worker(urlDoWorker)

      let date

      try {
        const result = await API.getTime.get({id})
        date = moment(result.body.time).toDate()
      } catch (e) {
        date = new Date()
      }

      this.worker.postMessage(date.toISOString())

      this.worker.addEventListener('message', (e) => {
        this.time = e.data
      })
    }
  }
}
</script>
